import React, {Component} from 'react';
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import Helmet from "react-helmet";
import './our-services.scss';
import Heading from "../../common/heading/heading";
import OurServices from "../../sections/ourservices/ourservices";
class OurServicesPage extends Component {
    render (){

        return (
            <div className="our-services-wrap">
                <Helmet>
                    <title>City Premium Realty | Our Services Page</title>
                </Helmet>
                <Breadcrumb title={`Our Services`}/>
                <div className="section-wrapper pt-0">
                    <OurServices/>
                </div>
                <div className="section-wrapper">
                    <div className="container">
                        <Heading>our Services - Style 03</Heading>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="icon-box">
                                    <div className="icon-box-wrap">
                                        <div className="icon-box-icon">
                                            <i className="opal-icon-like"></i>
                                        </div>
                                        <div className="icon-box-content">
                                            <h3 className="icon-box-title text-uppercase">
                                                <span>Human-Centered Design Friendly Spaces</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-list">
                                    <div className="icon-list-wrap">
                                        <ul>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Wake-up call</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Sightseeing</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Car hire, Bicycle hire</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Laundry and dry cleaning</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Option to borrow a fridge for the room</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Own parking space</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="icon-box">
                                    <div className="icon-box-wrap">
                                        <div className="icon-box-icon">
                                            <i className="opal-icon-user"></i>
                                        </div>
                                        <div className="icon-box-content">
                                            <h3 className="icon-box-title text-uppercase">
                                                <span>Dedicated Production And Planning Teams</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-list">
                                    <div className="icon-list-wrap">
                                        <ul>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Room service</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Allergy friendly rooms</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Rooms with connecting doors</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Air conditioning in all rooms</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Coffee and tea facilities in all rooms</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Free Wi-Fi in all rooms</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="icon-box">
                                    <div className="icon-box-wrap">
                                        <div className="icon-box-icon">
                                            <i className="opal-icon-coffee"></i>
                                        </div>
                                        <div className="icon-box-content">
                                            <h3 className="icon-box-title text-uppercase">
                                                <span>Premium, Fresh Cuisine Made Onsite</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-list">
                                    <div className="icon-list-wrap">
                                        <ul>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Fitness Center</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Sightseeing</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Business lounge with free </span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Wi-Fi</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Six conference rooms</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Free WiFi in meeting rooms, lobby and restaurants</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="icon-box">
                                    <div className="icon-box-wrap">
                                        <div className="icon-box-icon">
                                            <i className="opal-icon-map"></i>
                                        </div>
                                        <div className="icon-box-content">
                                            <h3 className="icon-box-title text-uppercase">
                                                <span>Flexible, Contemporary Spaces</span>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="icon-list">
                                    <div className="icon-list-wrap">
                                        <ul>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">24-hour reception</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Check-in possible after 15.00</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Latest check-out by 12.00</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Breakfast buffet</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Lunch from 11.00</span>
                                            </li>
                                            <li className="icon-list-items">
                                                <span className="icon-list-icon">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                                <span className="icon-list-text">Dinner from 17.30</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OurServicesPage